<template>
  <v-select
    v-model="item"
    dir="rtl"
    :clearable="clearable"
    :multiple="multiple"
    label="Title"
    :reduce="x => x.Id"
    :options="options"
    :loading="loading"
    @open="onOpen"
  >
    <span
      slot="no-options"
      @click="$refs.select.open = false"
    >
      موردی یافت نشد
    </span>
    <template #spinner>
      <div class="demo-inline-spacing">
        <b-spinner
          v-if="loading"
          class="m-0"
          small
          variant="secondary"
        />
      </div>
    </template>
  </v-select>
</template>

<script>

export default {
  name: 'ZCustomsProcedure',
  props: {
    value: {
      type: [Number, Array],
      default: null,
    },
    clearable: {
      type: Boolean,
      default: false,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    // null = همه ، false = رویه گمرکی ، true = ترانزیت
    isTransit: {
      type: Boolean,
      default: null,
    },
  },
  data() {
    return {
      items: [],
      val: this.value,
      loading: false,
    }
  },
  computed: {
    options() {
      if (this.isTransit === null) {
        return this.items
      }
      return this.items.filter(x => x.IsTransit === this.isTransit)
    },
    item: {
      get() {
        if (this.value) {
          this.get()
        }
        return this.val
      },
      set(newValue) {
        this.$emit('input', newValue)
        this.val = newValue
      },
    },
  },
  watch: {
    value(v) {
      this.val = v
    },
  },
  methods: {
    get() {
      if (this.items.length === 0) {
        this.loading = true
        this.$http.post(
          this.$api.customsprocedure.getall, {},
        )
          .then(res => {
            this.items = res.data
            this.loading = false
          })
      }
    },
    onOpen() {
      this.get()
    },
  },
}
</script>
